import { FeatureCode, useGetCommunityDmStatusQuery } from 'generated/graphql';
import { resolveInfluencerId } from '../lib/resolveInfluencerId';

export const useIsDmFeatureEnabled = (
  influencerId?: string | number,
): boolean => {
  const creatorId = resolveInfluencerId(influencerId);

  const { data } = useGetCommunityDmStatusQuery({
    variables: { id: creatorId ?? 0 },
    skip: creatorId === null,
  });

  return (data?.creator?.features ?? []).some(
    (feature) => feature?.code === FeatureCode.Dm,
  );
};
